import { render, staticRenderFns } from "./attendanceConfiguration.vue?vue&type=template&id=db1c112a&"
import script from "./attendanceConfiguration.vue?vue&type=script&lang=js&"
export * from "./attendanceConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./attendanceConfiguration.vue?vue&type=style&index=0&id=db1c112a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports